import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "q-chip__text" }


import {useFiltersStore} from "@/store/SerpPage/FiltersStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'MarkedFilterButton',
  props: ['activeFilter', 'filterName'],
  setup(__props) {



const filtersStore = useFiltersStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.activeFilter, (selectedFilter) => {
    return (_openBlock(), _createElementBlock("button", {
      type: "button",
      class: "serp__filters--marked-item-button q-btn q-btn-sm q-btn-light q-me-2 q-mb-2 q-position-relative q-rounded-3 q-shadow-sm",
      key: selectedFilter,
      onClick: _withModifiers(($event: any) => (_unref(filtersStore).updateFilter(__props.filterName, selectedFilter)), ["stop","prevent"])
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(filtersStore).getFilterLabelByFilterName(__props.filterName)) + ": " + _toDisplayString(selectedFilter), 1),
      _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "q-chip__close",
        "aria-hidden": "true"
      }, [
        _createElementVNode("svg", {
          class: "q-chip__icon",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            d: "M6 6l12 12M18 6L6 18",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round"
          })
        ])
      ], -1))
    ], 8, _hoisted_1))
  }), 128))
}
}

})